/* eslint-disable prefer-destructuring */
/* eslint-disable default-param-last */
/*
    Import all your mocks for endpoints.
    USE_MOCKS is derived directly from import.meta.env.VITE_USE_MOCKS (a statically-known build-time
    value), so Rollup/esbuild can constant-fold the `if (USE_MOCKS)` branch below and tree-shake the
    mock imports out of the bundle when it's false. If USE_MOCKS is ever changed to come from a
    runtime source (e.g. localStorage), this guarantee breaks silently and mock data would ship in
    production.
    USE_MOCKS should be false for production!
 */
import * as ApiConfig from './ApiConfig';
import Util from './Util';
import getFoldersMock from '../mocks/getFolders';
import getFolderMock from '../mocks/getFolder';
import getChildFoldersMock from '../mocks/getChildFolders';
import tagsMock from '../mocks/tags';
import assetTagsMock from '../mocks/assetTags';
import getMediaMock from '../mocks/getMedia';

const USE_MOCKS = import.meta.env.VITE_USE_MOCKS ? Util.getBoolean(import.meta.env.VITE_USE_MOCKS) : false;

async function throttle(ms) {
    // eslint-disable-next-line no-promise-executor-return
    return new Promise(resolve => setTimeout(resolve, ms));
}

// eslint-disable-next-line import/prefer-default-export, import/no-mutable-exports
export let smartFetch; // Based on USE_MOCKS, either get mock data or make an actual fetch to endpoints

if (USE_MOCKS) {
    // DO NOT TOUCH: relies on USE_MOCKS being statically-analyzable (see file header) for this
    // whole block to be dead-code-eliminated when VITE_USE_MOCKS is unset/false
    const mocks = {
        getFolders: getFoldersMock,
        getFolder: getFolderMock,
        getChildFolders: getChildFoldersMock,
        tags: tagsMock,
        assetTags: assetTagsMock,
        getMedia: getMediaMock
    };

    smartFetch = async (url_, method = 'GET') => {
        await throttle(1000);

        let url = url_;
        let parmStr = url.match(/\?.*$/);
        if (parmStr) {
            parmStr = parmStr[0];
            const urlLessParms = url.replace(parmStr, '');
            parmStr = parmStr.replace('?', '');
            url = urlLessParms;
        }
        let service = url.match(/\/([^/]+)\/?$/)[1];
        if (service === 'tags') {
            if (url.includes('/asset/')) {
                service = 'assetTags';
            }
        }

        // some ml3 write endpoints aren't as easily parsed
        const writeEndpoint = method !== 'GET';
        if (method === 'PUT' && url.includes('/alt/')) {
            service = 'updateAltText';
        } else if (method === 'PATCH' && url.includes('/label')) {
            service = 'updateAssetLabel';
        }

        // eslint-disable-next-line no-console
        console.log(
            `%c smartFetch (mocks[${service}]): ${method} ${url}`,
            'background: #ADD8E6; font-weight: bold; color: #333333'
        );

        if (mocks[service]) {
            const data = mocks[service];
            if (data) {
                if (parmStr) {
                    const parmList = parmStr.split('&');
                    if (parmList.length >= 1) {
                        parmStr = parmList.shift();
                    }

                    let rdata = null;
                    if (data[parmStr]) {
                        rdata = data[parmStr];
                    } else if (data.generic) {
                        rdata = data.generic;
                    }
                    if (rdata && parmList.length) {
                        const newdata = {...rdata, result: rdata.content.slice(0)};

                        parmList.forEach(request => {
                            const name = request.split('=')[0];
                            const value = request.split('=')[1];

                            if (name === 'page') {
                                newdata.page = parseInt(value, 10);
                                newdata.hasNext = newdata.page < newdata.maxPageCount;
                                newdata.hasPrevious = newdata.page === 1;
                                newdata.start = parseInt(value, 10);
                            }

                            if (name === 'size') {
                                newdata.count = value;
                                newdata.content = newdata.result.slice(
                                    newdata.page * value,
                                    (newdata.page + 1) * value
                                );
                            }
                        });
                        return newdata;
                    }
                    return rdata;
                }
                return data;
            }
        } else if (writeEndpoint) {
            return {id: 'success'};
        }
        return null;
    };
} else {
    smartFetch = async (url, method = 'GET', payload, form = false) => {
        try {
            const res =
                method === 'GET' || method === 'PUT' || method === 'DELETE'
                    ? await ApiConfig.ccFetch(url, method, true)
                    : await ApiConfig.ccFetch(url, method, true, form, false, payload);
            if (res) {
                return res;
            }
            return new Error('No Results');
        } catch (error) {
            return error;
        }
    };
}
